@use '../../../../styles/Constants.scss' as Constants;
.label {
	margin-bottom: Constants.$val-spacing-xs;

	&__with-tooltip {
		display: flex;
		align-items: center;
	}
}